import Input from '../common/Input'

const WebsiteConnectionUpdateForm = ({ register, errors, selectedPlatform }) => {
  const shouldShowApiKey = selectedPlatform !== 'shopify'

  return (
    <form className="space-y-4">
      <Input label="Site Name" {...register('siteName')} error={errors.siteName?.message} />
      {shouldShowApiKey && (
        <Input
          label="API Key"
          type="text"
          placeholder="Leave empty to keep existing API key"
          {...register('apiKey')}
          error={errors.apiKey?.message}
          helperText="Leave empty if you don't want to update the API key"
        />
      )}
      <div className="flex items-center gap-3">
        <input type="checkbox" id="isActive" {...register('isActive')} className="w-5 h-5" />
        <label htmlFor="isActive" className="text-sm text-text-dark cursor-pointer">
          Active
        </label>
      </div>
    </form>
  )
}

export default WebsiteConnectionUpdateForm
